import Hourglass from '../../src/legacy/Hourglass';
export default Hourglass;
